<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormat"
        label="Escolha a Data"
        prepend-icon-inner="mdi-calendar"
        readonly
        v-on="on"
        outlined
        hide-details
        @click:clear="clear()"
        dense
        clearable
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable locale="pt-br" range>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="send()">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    date: [],
    menu: false,
  }),
  props: {
    value: Array,
    ok: Function,
  },
  computed: {
    dateFormat() {
      const dates = []
      if (!this.date || !Array.isArray(this.date)) {
        return
      }
      let alreadyDates = this.date
      
      alreadyDates.sort()
      alreadyDates.forEach((element) => {
        dates.push(this.$options.filters.formatDate(element))
      })
      return dates.join(' à ')
    },
  },
  methods: {
    send() {
      this.menu = false
      this.$emit('input', this.date)
      this.$emit('ok')
    },
    clear() {
      this.date = []
      this.menu = false
      this.$emit('input', this.date)
      this.$emit('ok')
    },
  },
  watch: {
    value() {
      this.date = this.value
    },
    date() {
      this.$emit('input', this.date)
    },
  },
}
</script>

<style></style>
